<template>
  <div>
    <div class="container">
      <div class="preview-box">
        <div class="title">壹人事企业服务-服务号</div>
        <div class="content">
          <div class="bottom-box">
            <img class="icon-keyword" src="@/assets/images/keyboard-box-fill.png" />
            <div class="one-list">
              <div
                class="one-keyword"
                v-for="(item, index) in oneList"
                :key="index"
                :class="{ active: tabIndex === index }">
                <div @click="clickMenu('edit',1,item,index)">
                  {{item.name}}
                </div>
                <div class="two-list" v-if="currentMenuIndex === index">
                  <div
                    class="two-keyword"
                    v-for="(item2, index2) in item.subMenuInfos"
                    :key="index2"
                    :class="{'active': tabIndex === (index+''+index2)}"
                    @click="clickMenu('edit',2,item2,index,index2)">
                    <i
                      v-if="tabIndex === (index+''+index2) && (index2 != 0)"
                      class="el-icon-top"
                      @click.stop="handleUp(index, index2)"></i>
                    {{item2.name}}
                    <i
                      v-if="tabIndex === (index+''+index2) && (index2 != item.subMenuInfos.length - 1)"
                      class="el-icon-bottom"
                      @click.stop="handleDown(index, index2)"></i>
                  </div>
                  <div
                    class="two-keyword two-keyword2"
                    :class="{'active': tabIndex === 99}"
                    v-if="item.subMenuInfos.length < 5"
                    @click="clickMenu('add',2,item,index)">
                    +
                  </div>
                </div>
              </div>
              <div
                class="one-keyword one-keyword2"
                :class="{'active': tabIndex === 9}"
                v-if="oneList.length < 3"
                @click="clickMenu('add',1,{},oneList.length)">
                +
              </div>
            </div>
          </div>
        </div>
        <div class="title2">预览</div>
      </div>
      <div class="edit-box" v-if="currentMenuIndex !== null">
        <div class="title">{{titleMenu}}</div>
        <el-form
          ref="form"
          label-width="120px"
          :model="form"
          :rules="rulesForm">
          <el-form-item label="名称：" prop="name">
            <el-input
              v-model="form.name"
              :placeholder="(titleMenu==='一级菜单信息'?placeholderName1:placeholderName2)"></el-input>
          </el-form-item>
          <el-form-item v-if="titleMenu === '一级菜单信息'" label="是否跳转：" prop="isJump">
            <el-radio-group v-model="form.isJump">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <div v-if="form.isJump == 0" class="hint">如果一级菜单没有配置子菜单,必须配置跳转,否则会报错</div>
          </el-form-item>
          <template v-if="form.isJump == 1">
            <el-form-item
              v-if="form.isJump == 1"
              label="类型："
              prop="typeInt">
              <el-radio-group v-model="form.typeInt" @change="handleTypeIntChange">
                <el-radio :label="1">URL链接</el-radio>
                <el-radio :label="2">小程序链接</el-radio>
                <el-radio :label="3">文字</el-radio>
                <el-radio :label="4">图片</el-radio>
                <el-radio :label="9999">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.typeInt == 1" label="URL链接：" prop="url">
              <el-input v-model="form.url"></el-input>
            </el-form-item>
            <el-form-item v-if="form.typeInt == 2" label="小程序链接：" prop="pagepath">
              <el-input v-model="form.pagepath"></el-input>
            </el-form-item>
            <el-form-item v-if="form.typeInt == 3 || form.typeInt == 4" label="key：" prop="key">
              <el-input v-model="form.key" maxlength="16"></el-input>
              <div class="hint">字数不多于16字符</div>
            </el-form-item>
            <el-form-item v-if="form.typeInt == 3" label="文字：" prop="value">
              <el-input
                v-model="form.value"
                type="textarea"
                :autosize="{ minRows: 3 }"
                maxlength="600">
              </el-input>
              <div class="hint">字数不多于600字</div>
            </el-form-item>
            <el-form-item v-if="form.typeInt == 4" prop="imgURL">
              <div style="display:flex;">
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :http-request="imgUploadRequest"
                  style="margin-right:20px;">
                    <el-button type="primary">点击上传</el-button>
                </el-upload>
                <img
                  class="img"
                  referrerpolicy="no-referrer"
                  v-if="form.imgURL"
                  :src="form.imgURL" 
                />
              </div>
            </el-form-item>
            <el-form-item v-if="form.typeInt == 9999">
              <div class="hint">其他类型待开放，建议先不要修改，怕会影响功能</div>
            </el-form-item>
          </template>

          <el-form-item>
            <el-button type="danger" :disabled="isSubmitting || isDeleting" @click="deleteBtn">删除</el-button>
            <el-button type="primary" :loading="isSubmitting" :disabled="isDeleting" @click="submitBtn">保存并发布</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 是否删除 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>是否确定删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="isDeleting" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="isDeleting" @click="confirmDelete">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pinyin } from 'pinyin-pro';

export default {
  components: {
  },
  data(){
    const validateMenuName = (rule, value, callback) => {
      const text = (value || '').trim();
      if (!text) {
        callback(new Error('请输入一级菜单名称'));
        return;
      }
      const len = text.replace(/[^\x00-\xff]/g, '**').length;
      const maxLen = this.titleMenu === '一级菜单信息' ? 8 : 16;
      if (len > maxLen) {
        callback(new Error(`名称不多于${maxLen / 2}个汉字或${maxLen}个字母`));
        return;
      }
      callback();
    };
    const validateMenuKey = (rule, value, callback) => {
      const text = (value || '').trim();
      if (!text) {
        callback(new Error('请输入key'));
        return;
      }
      if (!/^[\u4e00-\u9fa5A-Za-z0-9_]+$/.test(text)) {
        callback(new Error('key仅支持中文、英文字母、数字、下划线'));
        return;
      }
      callback();
    };
    return {
      oneList:[],
      tabIndex:9,
      currentMenuIndex:null,
      titleMenu:'一级菜单信息',
      dialogVisible:false,
      clickType:'add', // add-新增 edit-编辑
      isSubmitting: false,
      isDeleting: false,
      placeholderName1:'字数不多于4个汉字或8个字母',
      placeholderName2:'字数不多于8个汉字或16个字母',
      form:{
        name:'',
        isJump:0,
        typeInt:0,
        url:'',
        pagepath:'',
        value:'',
        imgURL:'',
        key:'',
      },
      rulesForm:{
        name:[
          { required: true, validator: validateMenuName, trigger: ['blur', 'change'] },
        ],
        isJump:[
          { required: true, message: '请选择是否跳转' },
        ],
        typeInt:[
          { required: true, message: '请选择类型'},
        ],
        url:[
          { required: true, message: '请输入URL链接' },
        ],
        pagepath:[
          { required: true, message: '请输入小程序链接' },
        ],
        value:[
          { required: true, message: '请输入文字' },
        ],
        imgURL:[
          { required: true, message: '请上传图片' },
        ],
        key:[
          { required: true, validator: validateMenuKey, trigger: ['blur', 'change'] },
        ],

      }
    }
  },
  created(){
    this.initList();
  },
  mounted(){
  },
  methods:{
    getDefaultForm() {
      return {
        name:'',
        isJump:0,
        typeInt:0,
        url:'',
        pagepath:'',
        value:'',
        imgURL:'',
        key:''
      };
    },
    // 初始化
    async initList() {
      const res = await this.$get(this.$api.GetCurrentSelfmenuInfo);
      if(res.isSuccess) {
        const list = res.data || [];
        list.forEach(item => {
          this.changeItemIsJump(item);
          item.subMenuInfos.forEach(subItem => this.changeItemIsJump(subItem));
        });
        await this.fillTypeExtraForList(list);
        this.oneList = list;
      }
    },
    changeItemIsJump(item) {
      item.isJump = item.typeInt == 0 ? 0 : 1;
      if (!Array.isArray(item.subMenuInfos)) {
        item.subMenuInfos = [];
      }
    },
    async fillTypeExtraForList(list) {
      const tasks = [];
      list.forEach(item => {
        tasks.push(this.fillTypeExtra(item));
        item.subMenuInfos.forEach(subItem => {
          tasks.push(this.fillTypeExtra(subItem));
        });
      });
      await Promise.all(tasks);
    },
    async fillTypeExtra(item) {
      if (item.typeInt != 3 && item.typeInt != 4) {
        return;
      }
      const res = await this.$get(this.$api.GetWxClickEventMessageByEventKey, { 
        eventKey: item.key
      });
      if(!res.isSuccess) return
      if(item.typeInt == 3) {
        item.value = res.data.value || '';
      } else if(item.typeInt == 4) {
        item.imgURL = res.data.imgURL || '';
      }
    },
    // radio的切换
    handleTypeIntChange() {
      if(this.form.typeInt == 2) {
        this.form.url = 'http://mp.weixin.qq.com';
      } else {
        this.form.url = '';
        this.form.pagepath = '';
      }
      
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    // 点击菜单
    clickMenu(type,level,item,index,index2){
      this.clickType = type; 
      this.titleMenu = level === 1 ? '一级菜单信息' : '子菜单信息';
      this.form = this.getDefaultForm();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
      if(this.clickType === 'add'){
        if(level === 1){
          this.tabIndex = 9;
          this.form.isJump = 0;
          this.form.typeInt = 0;
        }else{
          this.tabIndex = 99;
          this.form.isJump = 1;
          this.form.typeInt = 1;
        }
      }else{
        this.form = JSON.parse(JSON.stringify(item));
        if(level === 1){
          this.tabIndex = index;
        }else{
          this.tabIndex = index + '' + index2;
        }
      }
      this.currentMenuIndex = index;
    },
    submitBtn() {
      if (this.isSubmitting) {
        return;
      }
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          this.isSubmitting = true;
          let data = this.form;
          try {
            if (data.typeInt == 3 || data.typeInt == 4) {
              const messageSaved = await this.wxClickEventMessage(data);
              if (!messageSaved) {
                return;
              }
            }
            let newObj = JSON.parse(JSON.stringify(this.oneList));

            if(this.clickType == 'add') {
              if(this.titleMenu == '一级菜单信息') {
                data.subMenuInfos = [];
                newObj.push(data);
              } else {
                newObj[this.currentMenuIndex].subMenuInfos.push(data);
              }
            } else {
              let numObj = this.parseTabIndex();
              if(numObj.level === 1) {
                newObj[numObj.oneIndex] = data;
              } else if (numObj.level === 2) {
                newObj[numObj.oneIndex].subMenuInfos[numObj.twoIndex] = data;
              }
            }

            await this.createdMenu(newObj);
          } finally {
            this.isSubmitting = false;
          }
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });
    },
    deleteBtn() {
      if (this.isDeleting) {
        return;
      }
      this.dialogVisible = true;
    },
    parseTabIndex() {
      const indexStr = String(this.tabIndex);
      if (indexStr.length === 1) {
        return { level: 1, oneIndex: Number(indexStr), twoIndex: null };
      }
      if (indexStr.length === 2) {
        return { level: 2, oneIndex: Number(indexStr[0]), twoIndex: Number(indexStr[1]) };
      }
      return { level: 0, oneIndex: null, twoIndex: null };
    },
    handleClose() {
      if (this.isDeleting) {
        return;
      }
      this.dialogVisible = false;
    },
    async confirmDelete() {
      if (this.isDeleting) {
        return;
      }
      this.isDeleting = true;
      try {
        let numObj = this.parseTabIndex();
        if(numObj.level === 1) {
          this.oneList.splice(numObj.oneIndex, 1);
        } else if (numObj.level === 2) {
          this.oneList[numObj.oneIndex].subMenuInfos.splice(numObj.twoIndex, 1);
        }
        let newObj = JSON.parse(JSON.stringify(this.oneList));
        let res =await this.$post(this.$api.CreateMenu, newObj);
        if(res.isSuccess) {
          this.$message.success('删除成功');
          this.dialogVisible = false;

          await this.$post(this.$api.TestAddMenuCache, newObj);

          this.resetData();
          this.initList();
        } else {
          this.$message.error(res.message || '删除失败');
        }
      } finally {
        this.isDeleting = false;
      }
    },
    tryAutoFillKey() {
      const nameText = (this.form.name || '').trim();
      if (!nameText || (this.form.key || '').trim()) {
        return;
      }
      let keyText = this.toPinyin(nameText);
      this.form.key = keyText.slice(0, 16);
    },
    resetData() {
      this.form = this.getDefaultForm();
      this.tabIndex = null;
      this.currentMenuIndex = null;
      this.titleMenu = '一级菜单信息';
      this.clickType = '';
    },
    // 文字转拼音
    toPinyin(text) {
      return pinyin(text, { toneType: 'none' }).replace(/\s/g, '');
    },
    // 文字和图片需要单独处理接口-新增
    async wxClickEventMessage(data) {
      let params = {
        wxAccountType: 1, // 1企业服务公众号,2员工服务公众号
        eventKey: data.key, 
        responseType: data.typeInt, 
        value: data.value, 
        imgURL: data.imgURL || ''
      };
      try {
        let res = null;
        if(this.tabIndex == 9 || this.tabIndex == 99) {
          // 新增
          res = await this.$post(this.$api.AddWxClickEventMessage, params);
        } else {
          let oldData = null;
          let numObj = this.parseTabIndex();
          if(numObj.level === 1) {
            oldData = this.oneList[numObj.oneIndex];
          } else if (numObj.level === 2) {
            oldData = this.oneList[numObj.oneIndex].subMenuInfos[numObj.twoIndex];
          }
          if(oldData.key != data.key) {
            // 也算新增
            res = await this.$post(this.$api.AddWxClickEventMessage, params);
          } else {
            // 更新
            res = await this.$post(this.$api.UpdateWxClickEventMessage, params);
          }
        }
        if (res && res.data) {
          return true;
        }
        this.$message.error(res.msg || '消息保存失败');
        return false;
      } catch (error) {
        this.$message.error('消息保存失败');
        return false;
      }
    },
    // 上传图片
    async imgUploadRequest(data) {
      let file=data.file;
      let fileExpand = file.name.slice(file.name.lastIndexOf("."));
      let formData = new FormData();
      formData.append('file', file);
      let res = await this.$haveFile(this.$api.UploadFileV2+'?module=wechat&fileExpand='+fileExpand,formData);
      if(res.isSuccess) {
        
        let res2 = await this.$haveFile(this.$api.AddMaterial,formData);
        if(res2.isSuccess) {
          this.$set(this.form, 'imgURL', res.data); // 图片链接
          this.form.value = res2.msg; // 素材id
          console.log(res.data,this.form.imgURL,'222');
        } else {
          this.$message.error('上传失败');
        }
      } else {
        this.$message.error(res.msg);
      }
      
    },
    // 上移
    handleUp(index,index2) {
      console.log(index,index2,'222');
      const subList = this.oneList[index] && this.oneList[index].subMenuInfos;
      if (!Array.isArray(subList) || index2 <= 0) {
        return;
      }
      const temp = subList[index2 - 1];
      this.$set(subList, index2 - 1, subList[index2]);
      this.$set(subList, index2, temp);
      this.tabIndex = index + '' + (index2 - 1);
      
      this.createdMenu(this.oneList);
    },
    // 下移
    handleDown(index,index2) {
      const subList = this.oneList[index] && this.oneList[index].subMenuInfos;
      if (!Array.isArray(subList) || index2 >= subList.length - 1) {
        return;
      }
      const temp = subList[index2 + 1];
      this.$set(subList, index2 + 1, subList[index2]);
      this.$set(subList, index2, temp);
      this.tabIndex = index + '' + (index2 + 1);

      this.createdMenu(this.oneList);
    },
    // 创建菜单
    async createdMenu(newObj) {
      let res =await this.$post(this.$api.CreateMenu, newObj);
      if(res.data) {
        // await this.$post(this.$api.TestAddMenuCache, newObj);
        // this.$message.success('保存并发布成功');
        await this.initList();
        return true;
      } else {
        this.$message.error(res.msg || '保存并发布失败');
        return false;
      }
    }

  }
};
</script>
<style lang="stylus" scoped>
.container {
  background: #fff;
  padding: 10px 10px;
  border-radius: 10px;
  display: flex;
  .preview-box {
    margin-left:100px;
    margin-right:100px;
    text-align: center;
    .title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .content {
      position:relative;
      width:420px;
      height:667px;
      border: 1px solid #eee;
      border-radius: 10px;
      .bottom-box {
        display: flex;
        align-items: center;
        position:absolute;
        bottom:0;
        width:100%;
        height:40px;
        border-top: 1px solid #eee;
        .icon-keyword {
          padding: 5px 10px;
          width:50px;
        }
        .one-list {
          display: flex;
          width:100%;
          height:100%;
          line-height: 38px;
          border-left: 1px solid #eee;
          .one-keyword {
            position:relative;
            flex:1;
            text-align: center;
            cursor:pointer;
            border: 1px solid transparent;
            border-right: 1px solid #eee
            &:last-child {
              border-right: 1px solid transparent;
            }
            &.active {
              border-color:#70B603;
            }
          }
          .one-keyword2 {
            font-size:30px;
            line-height:32px;
          }
        }
        .two-list {
          position:absolute;
          left:0;
          bottom:calc(100% + 1px);
          width:100%;
          z-index:10;
          .two-keyword {
            position: relative;
            width:100%;
            height:40px;
            line-height:40px;
            border: 1px solid #eee;
            &.active {
              border-color:#70B603;
            }
            .el-icon-top {
              position: absolute;
              left: -30px;
              font-size: 26px;
              top: 5px;
            }
            .el-icon-bottom {
              position: absolute;
              right: -30px;
              font-size: 26px;
              top: 5px;
            }
          }
          .two-keyword2 {
            font-size:30px;
            line-height:32px;
          }
        }
      }
    }
    .title2 {
      font-size: 18px;
      font-weight: 500;
      margin-top: 10px;
    }
  }
  .edit-box {
    padding: 30px 20px;
    margin-top:100px;
    width:620px;
    height:fit-content;
    border: 1px solid #eee;
    border-radius: 10px;
    .title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 30px;
    }
    .el-button+.el-button {
      margin-left:30px;
    }
    .hint {
      margin-top: 5px;
      font-size: 12px;
      color: #999;
    }
    .img {
      width:148px;
      height:148px;
      border-radius: 6px;
    }
  }
}
</style>